import { BasketWrapper } from '@core';
import { ChronodriveUserWrapper } from './chronodrive-user-wrapper';
import { ChronodriveStoreWrapper } from './chronodrive-store-wrapper';

export class ChronodriveBasketWrapper extends BasketWrapper {

  // TODO
  hasPayment() {
    return false;
  }

  // TODO
  listenToRetailerBasket(retailerBasketChangeCallBack) {
    return null;
  }

  // Read current basket from miniCartZone element in DOM (or cartDetailZone when on basket page)
  getBasketProducts() {
    let cart = document.getElementById('miniCartZone') || document.getElementById('cartDetailZone');
    const itemElems = cart.getElementsByClassName('item');
    
    let basketProducts = [];
    Array.from(itemElems).forEach(elem => {
      const cugContainer = elem.getElementsByClassName('item-actions')[0];
      const qtyContainer = cugContainer.getElementsByClassName('qte_basket')[0];
      if (cugContainer && qtyContainer) {
        basketProducts.push({
          id: cugContainer.getAttribute('data-cug'),
          quantity: parseInt(qtyContainer.textContent)
        })
      }
    });

    return basketProducts;
  }

  // Push products to Chrono basket using mobile API
  // Requires a token from mobile API (implemented in UserWrapper)
  // TODO: refresh page when modal closed to reload basket ?
  pushProductsToBasket(products) {
    ChronodriveUserWrapper.getAuthToken(token => {
      if (token) {
        const userId = new ChronodriveUserWrapper().getUserId();
        const shopId = new ChronodriveStoreWrapper().getPosExtId();
        // itemId:quantity:miam;itemId2:quantity2:miam
        const cugs = products.map(p => `${p.id}:${p.quantity}:miam`).join(';');
        const params = `v2=true&token=${token}&userId=${userId}&shopId=${shopId}&cugs=${cugs}`;

        let req = new XMLHttpRequest();
        req.open('post', 'https://www.chronodrive.com/mobile/ws/SendCart', true);
        req.addEventListener('load', this._refreshCartDisplay);
        req.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        return req.send(params);
      }
    })
  }

  // TODO: fix naming + remove???
  // From Chrono to Miam format
  mapEntryToProduct(entry) {
    return entry;
  }

  // TODO: fix naming
  // From Miam to Chrono format
  mapProductToEntry(attributes, quantity){
    return {
      id: attributes['ext-id'],
      quantity: quantity
    };
  }

  // Fetches current page and replaces miniPanier & menu entry blocks in DOM
  // Used after items are pushed to Chrono basket, to reload basket total without reloading the page
  _refreshCartDisplay() {
    let req = new XMLHttpRequest();
    req.open('get', location.href, true);
    req.addEventListener('load', () => {
      const page = document.createElement('div');
      page.innerHTML = this.responseText;

      const newCartMenu = page.querySelector('a#m_panier');
      const existingCartMenu = document.body.querySelector('a#m_panier');
      existingCartMenu.parentNode.replaceChild(newCartMenu, existingCartMenu);

      const newMiniCart = page.querySelector('div#miniCartZone');
      const existingMiniCart = document.body.querySelector('div#miniCartZone');
      existingMiniCart.parentNode.replaceChild(newMiniCart, existingMiniCart);
    });
    req.send();
  }
}